import {SwiperImpl as Swiper} from '@/app/js/swiper/swiper'

export function initProductMainSwipers() {
  let galleryThumbs = undefined

  const productSliderPaginationEl = document.querySelector('.js-product-slider-pagination')
  if (productSliderPaginationEl) {
    let paginationSlidesPerView = 5
    const videoSlide = productSliderPaginationEl.querySelector('.js-product-slider-pagination__video-slide')
    if (videoSlide && window.getComputedStyle(videoSlide).display === 'none') {
      videoSlide.remove()
    }

    if (productSliderPaginationEl.dataset.length < paginationSlidesPerView) {
      paginationSlidesPerView = parseInt(productSliderPaginationEl.dataset.length)
    }

    galleryThumbs = new Swiper('.js-product-slider-pagination', {
      spaceBetween: 10,
      direction: 'horizontal',
      centeredSlides: true,
      centeredSlidesBounds: true,
      navigation: {
        prevEl: '.js-product-slider-pagination-arrow-prev',
        nextEl: '.js-product-slider-pagination-arrow-next',
      },
      slidesPerView: paginationSlidesPerView,
    })
  }

  const sliderOptions = {
    spaceBetween: 30,
    direction: 'horizontal',
    slidesPerView: 1,
    navigation: {
      prevEl: '.js-product-slider-arrow-prev',
      nextEl: '.js-product-slider-arrow-next',
    },
  }

  if (galleryThumbs !== undefined) {
    sliderOptions['thumbs'] = {
      swiper: galleryThumbs
    }
  }

  if (document.querySelector('.js-product-slider')) {
    new Swiper('.js-product-slider', sliderOptions)
  }
}
